import React, { useEffect, useRef, useState } from "react";
import { toZonedTime, format } from 'date-fns-tz';
import { DateTime } from 'luxon';
import ResultTable from "../../components/ResultTable";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import { Col, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "../../pages/login/css/main.login.css";
import Cookies from "js-cookie";

const LobbyRoom: React.FC = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [dataRoom, setDataRoom] = useState<any>();
  const [coin, setCoin] = useState(0);
  const [sessionCapital, setSessionCapital] = useState<number | null>(null);
  const [sessionBetAmount, setSessionBetAmount] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [rateWin, setRateWin] = useState<number>();
  const [isPlayer, setIsPlayer] = useState<string>();
  const [image, setImage] = useState<string>();
  const [tableRound, setTableRound] = useState<any>();
  const [shuffle, setShuffle] = useState<number | null>(null);
  const [selectedKey, setSelectedKey] = useState<number | null>(1);
  const [currentCapital, setCurrentCapital] = useState<number | null>(null);

  const tableContainerRef = useRef<HTMLDivElement | null>(null);
  const lastProcessedRoundRef = useRef<number | null>(null);
  const lastIsPlayerRef = useRef<string | undefined>(undefined);

  const { id } = useParams();
  const token = Cookies.get("access_token");

  const userInfoString = localStorage.getItem("user_info");
  const navigate = useNavigate();

  useEffect(() => {
    const capitalStr = localStorage.getItem("session_capital");
    const betStr = localStorage.getItem("session_bet_amount");

    if (capitalStr) {
      const n = Number(capitalStr);
      if (!Number.isNaN(n)) {
        setSessionCapital(n);
        setCurrentCapital(n);
        localStorage.setItem("session_current_capital", String(n));
        console.log("[ROOM] Init session_capital =", n);
      }
    }

    if (betStr) {
      const n = Number(betStr);
      if (!Number.isNaN(n)) {
        setSessionBetAmount(n);
        console.log("[ROOM] Init session_bet_amount =", n);
      }
    }
  }, []);

  useEffect(() => {
    if (dataRoom?.totalRound?.length) {
      axios
        .post(
          `${process.env.REACT_APP_URL_API}/users/subtract-coins-for-action`,
          {
            amount: 1,
            action: "PLAY_GAME",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((data) => setCoin(data.data.coins))
        .catch((err) => {
          if (
            err.status === 400 &&
            err.response.data.message ===
              "Số xu hiện tại không đủ để thực hiện hành động: PLAY_GAME"
          ) {
            Swal.fire({
              icon: "error",
              title: "Lỗi tải dữ liệu",
              text: err.response.data.message,
              customClass: {
                popup: "bg-custom-image text-white",
              },
            });
            navigate("/casino/lobby");
          }
        });
    }
  }, [dataRoom?.totalRound?.length, token, navigate]);

  if (userInfoString) {
    const userInfo = JSON.parse(userInfoString);

    userInfo.coins = coin;

    localStorage.setItem("user_info", JSON.stringify(userInfo));
  }

  useEffect(() => {
    if (dataRoom === undefined) {
      setLoading(true);

      Swal.fire({
        title: "Đang tải dữ liệu trò chơi",
        html: "<p class='swal-loading-subtext'>Load Data.</p><div class='swal-loading-dots'><span class='swal-dot swal-dot-cyan'></span><span class='swal-dot swal-dot-orange'></span></div>",
        customClass: {
          popup: "swal-loading-modal",
        },
        allowOutsideClick: false,
        showConfirmButton: false,
      });
    }
    if (dataRoom) {
      // Khi có data thì đóng Swal
      Swal.close();
      setLoading(false);
    }
  }, [dataRoom]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      axios
        .get(
          `${process.env.REACT_APP_URL_API_CASINO}/predict/get-table-by-name?tableName=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((data) => {
          setRateWin(data.data.percentCurrent.Forecast);
          setIsPlayer(data.data.percentCurrent.Round);
          setDataRoom(data.data);
        })
        .catch((err) => console.log(err));
    }, 1000); // Delay 1 giây

    return () => clearTimeout(timeout);
  }, [id, token, dataRoom]);

  useEffect(() => {
    if (isPlayer === "P") {
      setImage("/assets/casino/symbol_p.png");
    } else {
      setImage("/assets/casino/symbol_b.png");
    }
    if (dataRoom) {
      setTableRound(dataRoom?.groupRoad);
    }
    if (dataRoom != null) {
      setShuffle(dataRoom.shuffle ?? null);
    }
    if (dataRoom && selectedKey === 1) {
      setTableRound(dataRoom?.ai0);
    }
    if (dataRoom && selectedKey === 2) {
      setTableRound(dataRoom?.ai1);
    }
    if (dataRoom && selectedKey === 3) {
      setTableRound(dataRoom?.ai2);
    }
    if (dataRoom && selectedKey === 4) {
      setTableRound(dataRoom?.ai3);
    }
    if (dataRoom && selectedKey === 5) {
      setTableRound(dataRoom?.ai4);
    }
    if (dataRoom && selectedKey === 6) {
      setTableRound(dataRoom?.ai5);
    }
  }, [isPlayer, dataRoom, selectedKey]);

  let countDown = 0;

  if (dataRoom?.statusGame === "GP_NEW_GAME_START") {
    const currentTime = dataRoom?.timeCurrent || DateTime.now().setZone("Asia/Ho_Chi_Minh", { keepLocalTime: false });
    const roundStartTime = dataRoom?.roundStartTime;
    const timePassed = currentTime - roundStartTime;
    const totalDuration = dataRoom?.iTime * 1000;
    const countDownUnix = Math.max(totalDuration - timePassed, 0);
    countDown = Math.floor(countDownUnix / 1000);
  }

  const formatNumber = (value: number | undefined | null) =>
    value != null ? value.toLocaleString("vi-VN") : "0";

  const getPredictionLabel = () =>
    isPlayer === "P" ? "PLAYER" : "BANKER";

  const getNextRoundText = () => {
    if (shuffle !== 0 && shuffle !== null) {
      return "Đang xào bài vui lòng chờ…";
    }
    if (countDown === 0) {
      return "Chờ kết quả trong giây lát…";
    }
    return `Vòng tiếp theo sẽ bắt đầu sau ${countDown}s`;
  };

  useEffect(() => {
    if (!tableContainerRef.current) return;
    const el = tableContainerRef.current;
    el.scrollTop = el.scrollHeight;
  }, [tableRound?.groupRoad?.table?.length]);
  // Cập nhật tổng vốn: dự đoán đúng (P/B trùng kết quả) thì cộng, sai thì trừ. Dùng dự đoán tại thời điểm ván đó (ref).
  useEffect(() => {
    if (!dataRoom || sessionCapital == null) return;

    const rounds = dataRoom.totalRound;
    if (!rounds || !rounds.length) return;

    const bet =
      sessionBetAmount ??
      (sessionCapital ? Math.floor(sessionCapital / 10) : 0);
    if (!bet || bet <= 0) return;

    // Lần đầu vào bàn: set mốc và lưu dự đoán hiện tại
    if (lastProcessedRoundRef.current == null) {
      lastProcessedRoundRef.current = rounds.length;
      lastIsPlayerRef.current = isPlayer;
      return;
    }

    if (rounds.length <= lastProcessedRoundRef.current) {
      lastIsPlayerRef.current = isPlayer;
      return;
    }

    const newRounds = rounds.slice(lastProcessedRoundRef.current);
    // Dự đoán áp dụng cho các ván mới = dự đoán đã lưu (trước khi API cập nhật isPlayer cho ván tiếp theo)
    const predicted: "B" | "P" =
      lastIsPlayerRef.current === "P" ? "P" : "B";

    let totalDelta = 0;
    newRounds.forEach((round: any) => {
      const road = round.road;
      let actual: "B" | "P" | "T";
      if (road === 0 || road === 1 || road === 2) {
        actual = "B";
      } else if (road === 8 || road === 9 || road === 10) {
        actual = "P";
      } else {
        actual = "T";
      }
      const isWin = actual === predicted;
      totalDelta += isWin ? bet : -bet;
    });

    if (totalDelta !== 0) {
      setCurrentCapital((prev) => {
        const base = prev ?? sessionCapital;
        const next = base + totalDelta;
        localStorage.setItem("session_current_capital", String(next));
        return next;
      });
    }

    lastProcessedRoundRef.current = rounds.length;
    lastIsPlayerRef.current = isPlayer;
  }, [dataRoom?.totalRound?.length, isPlayer, sessionCapital, sessionBetAmount]);

  return (
    <>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
      <div
        className="w-full min-h-screen mx-auto text-white relative p-4"
        id="app"
      >
        {!loading && (
          <div className="container mx-auto flex justify-center">
            <div
              className="w-full max-w-[1520px] px-3 md:px-5 flex flex-col items-stretch"
              style={{
                minHeight: 776,
                borderRadius: 17,
                border: "2.6px solid #00FF6F",
                backgroundColor: "rgba(0, 41, 29, 0.85)",
              }}
            >
              <div className="flex items-center mb-2 md:mb-6 pt-3 md:pt-6">
                <button
                  type="button"
                  onClick={() => navigate("/casino/lobby")}
                  className="flex items-center gap-2 cursor-pointer hover:opacity-90"
                >
                  <img
                    src="/assets/arrow-back.png"
                    alt="Back"
                    className="w-6 h-6 object-contain"
                  />
                  <span className="text-white font-semibold text-xl tracking-wide">
                    BACK
                  </span>
                </button>
              </div>

              <Row className="w-full flex justify-between" gutter={[12, 12]}>
              {/* Div 1: Dự đoán + Tỉ lệ thắng bàn */}
              <Col xs={24} md={5}>
                <div className="flex flex-col gap-4">
                  <div
                    className="p-4"
                    style={{
                      backgroundImage: "url(/assets/bg-frame.png)",
                      backgroundSize: "100% 100%",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <h2 className="text-lg md:text-xl font-semibold mb-3 text-center text-[#00d961] uppercase">
                      Dự đoán
                    </h2>
                    <div className="flex flex-col items-center">
                      <img
                        src={image}
                        alt={getPredictionLabel()}
                        style={{ width: 183, height: 183 }}
                        className="object-contain mb-3"
                      />
                      <p className="text-[35px] font-extrabold tracking-wide mb-2">
                        {getPredictionLabel()}
                      </p>
                      <p className="text-xs md:text-sm text-emerald-100 mb-1">
                        Số tiền đặt cược:{" "}
                        <span className="font-semibold text-yellow-300">
                          {formatNumber(
                            sessionBetAmount ??
                              (sessionCapital ? Math.floor(sessionCapital / 10) : coin)
                          )}
                        </span>
                      </p>
                      <p className="text-xs md:text-sm text-emerald-100 text-center">
                        {getNextRoundText()}
                      </p>
                    </div>
                  </div>
                  <div className="p-4 flex flex-col items-center justify-center">
                    <h2 className="text-xl md:text-2xl font-semibold mb-2 text-[#00d961] uppercase">
                      Tỉ lệ thắng bàn
                    </h2>
                    <div className="box-frame-result flex items-center justify-center mt-1">
                      <span className="score-board-percent text-[#00ffe1] font-bold leading-none drop-shadow-[0_0_6px_#00ffe1]">
                        {tableRound?.percentCurrent?.Forecast != null
                          ? `${Math.round(tableRound.percentCurrent.Forecast)}%`
                          : "--"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              {/* Div 2: AE Casino + Tổng số vốn + Bảng kết quả + tổng kết */}
              <Col xs={24} md={14}>
                <div
                  className="w-full flex flex-col gap-3 items-center px-4 md:px-8"
                  style={{ marginTop: "-6px" }}
                >
                  <h1 className="text-3xl md:text-5xl font-extrabold text-center text-white drop-shadow-[0_0_12px_rgba(0,255,157,0.8)]">
                    AE CASINO
                  </h1>
                  <div
                    className="px-8 py-3 rounded-full shadow-[0_0_22px_rgba(0,255,0,0.9)]"
                    style={{
                      backgroundColor: "rgba(0, 24, 12, 0.95)",
                      border: "2px solid #00FF00",
                    }}
                  >
                    <span className="text-lg md:text-2xl font-semibold text-yellow-300 mr-2">
                      Tổng số vốn:
                    </span>
                    <span className="text-lg md:text-2xl font-bold text-yellow-300">
                      {formatNumber(currentCapital ?? sessionCapital ?? coin)}
                    </span>
                  </div>
                  <div
                    className="w-full rounded-xl overflow-hidden"
                    style={{ backgroundColor: "rgba(0, 68, 55, 0.75)" }}
                  >
                    <div className="md:p-4 p-0">
                      <ResultTable tableData={dataRoom?.totalRound} />
                    </div>
                  </div>

                  <div
                    className="w-full rounded-xl p-4 grid grid-cols-1 md:grid-cols-3 gap-4"
                    style={{ backgroundColor: "rgba(0, 68, 55, 0.75)" }}
                  >
                    <div className="flex flex-col items-center justify-center">
                      <p className="text-sm md:text-base text-emerald-200 font-semibold mb-1 uppercase">
                        Tổng kết quả
                      </p>
                      <p className="text-xl md:text-2xl font-bold text-white">
                        {tableRound?.groupRoad?.total?.group ?? 0}
                      </p>
                    </div>
                    <div className="flex flex-col items-center justify-center">
                      <p className="text-sm md:text-base text-emerald-200 font-semibold mb-1 uppercase">
                        Tổng ván thắng
                      </p>
                      <p className="text-xl md:text-2xl font-bold text-[#00ff9d]">
                        {tableRound?.groupRoad?.total?.win ?? 0}
                      </p>
                    </div>
                    <div className="flex flex-col items-center justify-center">
                      <p className="text-sm md:text-base text-emerald-200 font-semibold mb-1 uppercase">
                        Tổng ván thua
                      </p>
                      <p className="text-xl md:text-2xl font-bold text-[#ff6b6b]">
                        {tableRound?.groupRoad?.total?.loss ?? 0}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={5}>
                <div className="col-12 col-md-12 d-flex align-items-center">
                  <div
                    className="chart-board round-table-wrap h-[420px] md:h-[600px]"
                    style={{
                      padding: "16px",
                      display: "flex",
                      flexDirection: "column",
                      backgroundImage: "url(/assets/bg-frame.png)",
                      backgroundSize: "100% 100%",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <table
                      className="round-table flex-shrink-0"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                      }}
                    >
                      <thead>
                        <tr>
                          <th className="round-th">Vòng</th>
                          <th className="round-th">Tay thắng</th>
                          <th className="round-th">Kết quả</th>
                        </tr>
                      </thead>
                    </table>

                    <div
                      ref={tableContainerRef}
                      style={{
                        flex: "1 1 0",
                        minHeight: 0,
                        overflowY: "auto",
                      }}
                    >
                        <table
                          className="round-table"
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        >
                          <tbody id="tbl_stack">
                            {tableRound &&
                              tableRound?.groupRoad?.table.map((value: any) => (
                                <tr key={value.id} className="round-tr">
                                  <td className="round-td round-td-vong">{value.id}</td>
                                  <td className="round-td round-td-taythang">
                                    {value.countWin === 0 ? "-" : <span>{value.countWin}</span>}
                                  </td>
                                  <td className="round-td round-td-ketqua">
                                    <span className={value.groupWin ? "round-badge round-badge-win" : "round-badge round-badge-lose"}>
                                      {value.groupWin ? "Thắng" : "Thua"}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                    </div>

                    <table
                      className="round-table flex-shrink-0"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                      }}
                    >
                      <tfoot className="round-tfoot">
                          <tr>
                            <th className="round-th">Tổng kết quả</th>
                            <th className="round-th">Thắng</th>
                            <th className="round-th">Thua</th>
                          </tr>
                          <tr>
                            <td id="total" className="round-td round-td-summary-value">{tableRound?.groupRoad?.total?.group}</td>
                            <td id="win" className="round-td round-td-summary-value">{tableRound?.groupRoad?.total?.win}</td>
                            <td id="lose" className="round-td round-td-summary-value">{tableRound?.groupRoad?.total?.loss}</td>
                          </tr>
                        </tfoot>
                    </table>
                  </div>
                </div>
              </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LobbyRoom;
